
import translations from '../assets/translations'

export const getTranslations = (language) => {
  if (!language || language.length === 0 || !translations[language.toLowerCase()]) {
    return translations['en']
  }
  return translations[language.toLowerCase()]
}



// WEBPACK FOOTER //
// ./src/helpers/translations.js